<mat-card class="decoration-card">
    <mat-card-content>
        <mat-toolbar *ngIf="!isReadonly">
            <button mat-icon-button matTooltip="update" (click)="updateVessel()" [disabled]="!isContentChanged"
                *ngIf="!isReadonly">
                <mat-icon>save</mat-icon>
            </button>

            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add a vessel" (click)="createVessel()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>

            <button mat-icon-button matTooltip="delete" (click)="btnDeleteClicked()" *ngIf="!isReadonly">
                <mat-icon>delete_outline</mat-icon>
            </button>

        </mat-toolbar>

        <form class="example-form" (change)="onContentChange()">
            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Name</mat-label>
                <input matInput type="text" name="vesselName" [(ngModel)]="vessel.name" [readonly]="isReadonly">
            </mat-form-field>

            <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                <mat-label>Description</mat-label>
                <textarea matInput type="text" name="Description" [(ngModel)]="vessel.description" [readonly]="isReadonly"></textarea>
            </mat-form-field>

            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>IMO No.</mat-label>
                            <input matInput type="text" name="IMONo" [(ngModel)]="vessel.imo_number" [readonly]="isReadonly">
                        </mat-form-field></td>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>IMO DP</mat-label>
                            <input matInput type="text" name="IMODP" [(ngModel)]="vessel.imo_dp_class" [readonly]="isReadonly">
                        </mat-form-field></td>
                </tr>
                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Class</mat-label>
                            <input matInput type="text" name="Class" [(ngModel)]="vessel.class_society" [readonly]="isReadonly">
                        </mat-form-field></td>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Class DP</mat-label>
                            <input matInput type="text" name="ClassDP" [(ngModel)]="vessel.dp_class" [readonly]="isReadonly">
                        </mat-form-field></td>
                </tr>
            </table>

            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Flag</mat-label>
                            <input matInput type="text" name="Flag" [(ngModel)]="vessel.flag" [readonly]="isReadonly">
                        </mat-form-field></td>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Construction Year</mat-label>
                            <input matInput type="number" name="consyear" [(ngModel)]="vessel.cons_year" [readonly]="isReadonly">
                        </mat-form-field></td>
                </tr>
            </table>
            
            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Tonnage</mat-label>
                            <input matInput type="number" name="tonnage" [(ngModel)]="vessel.tonnage" [readonly]="isReadonly">
                        </mat-form-field></td>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Length overall</mat-label>
                            <input matInput type="number" name="length" [(ngModel)]="vessel.length" [readonly]="isReadonly">
                        </mat-form-field></td>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>draught</mat-label>
                            <input matInput type="number" name="draught" [(ngModel)]="vessel.draught" [readonly]="isReadonly">
                        </mat-form-field></td>
                </tr>
            </table>

            <table class="example-full-width" cellspacing="0">
                <tr>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Anniversary</mat-label>
                            <input matInput type="date" name="anniversary" [(ngModel)]="vessel.anniversary" [readonly]="isReadonly">
                            <mat-hint>DD/MM/YYYY</mat-hint>
                        </mat-form-field></td>
                    <td><mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                            <mat-label>Last trial</mat-label>
                            <input matInput type="date" name="lastTrail" [(ngModel)]="vessel.last_trail" [readonly]="isReadonly">
                            <mat-hint>DD/MM/YYYY</mat-hint>
                        </mat-form-field></td>
                </tr>
            </table>

        </form>

    </mat-card-content>
</mat-card>